import { ServiceConfig } from "./service";

export let Api = {
  Agent: {
    AMLCheck: ServiceConfig.endpoint + "/aml/check",
    MyPage: ServiceConfig.endpoint + "/agent/mypage/confirm",
    MyPageUpdate: ServiceConfig.endpoint + "/agent/mypage/update",
    PasswordUpdate: ServiceConfig.endpoint + "/agent/password/update",
    Login: ServiceConfig.endpoint + "/agent/login",
    Logout: ServiceConfig.endpoint + "/agent/logout",
    Home: ServiceConfig.endpoint + "/agent/home",
    User: ServiceConfig.endpoint + "/agent/user",
    UserNationalityList:
      ServiceConfig.endpoint + "/agent/user/nationality/list",
    UserOccupationList: ServiceConfig.endpoint + "/agent/user/occupations",
    UserRegister: ServiceConfig.endpoint + "/agent/user/registration",
    UserCheck: ServiceConfig.endpoint + "/agent/user/registration/check",
    UserAccountRegistration:
      ServiceConfig.endpoint + "/agent/user/account/registration",
    UserModify: ServiceConfig.endpoint + "/agent/user/update",
    UserValidateMobile: ServiceConfig.endpoint + "/agent/user/validate/mobile",
    UserValidateMobileResult:
      ServiceConfig.endpoint + "/agent/user/validate/mobile/result",
    UserReAuthMobile:
      ServiceConfig.endpoint + "/agent/user/validate/mobile/reauth",
    UserVerifyMobile:
      ServiceConfig.endpoint + "/agent/user/validate/mobile/verify",
    UserTransactionList:
      ServiceConfig.endpoint + "/agent/user/transaction/list",
    UserStatistics: (id, year, type) => {
      return (
        ServiceConfig.endpoint +
        "/agent/user/" +
        id +
        "/" +
        year +
        "/" +
        type +
        "/statistics"
      );
    },
    UserRemittance: (id) => {
      return ServiceConfig.endpoint + "/agent/user/" + id + "/remittance";
    },
    UserAccountValidation:
      ServiceConfig.endpoint + "/agent/user/account/validation",
    Transaction: ServiceConfig.endpoint + "/agent/transaction",
    TransactionDetail: ServiceConfig.endpoint + "/agent/transaction/detail",
    TransactionHold: ServiceConfig.endpoint + "/agent/transaction/hold",
    TransactionCancel: ServiceConfig.endpoint + "/agent/transaction/cancel",
    TransactionApprove: ServiceConfig.endpoint + "/agent/transaction/approve",
    TransactionConfirm: ServiceConfig.endpoint + "/agent/transaction/confirmed",
    TransactionSender:
      ServiceConfig.endpoint + "/agent/transaction/send/sender",
    TransactionReceiver: (id) => {
      return (
        ServiceConfig.endpoint +
        "/agent/transaction/send/sender/" +
        id +
        "/receiver"
      );
    },
    TrnasactionCountry:
      ServiceConfig.endpoint + "/agent/transaction/send/country",
    TrnasactionPayoutBranch: (partner, bank_code) => {
      return (
        ServiceConfig.endpoint +
        "/agent/transaction/send/" +
        partner +
        "/bank/" +
        bank_code +
        "/branch"
      );
    },
    TrnasactionPayoutBank: (partner) => {
      return (
        ServiceConfig.endpoint + "/agent/transaction/send/" + partner + "/bank"
      );
    },
    TrnasactionPayoutBankByType: (partner, type) => {
      return (
        ServiceConfig.endpoint +
        "/agent/transaction/send/" +
        partner +
        "/bank/" +
        type
      );
    },
    TrnasactionPayoutCashBranch: (partner) => {
      return (
        ServiceConfig.endpoint + "/agent/transaction/send/" + partner + "/cash"
      );
    },
    TransactionPayoutBranchByType: (partner, type) => {
      return (
        ServiceConfig.endpoint +
        "/agent/transaction/send/" +
        partner +
        "/" +
        type
      );
    },
    PartnerDetail: (partner_id) => {
      return ServiceConfig.endpoint + "/agent/partner/" + partner_id;
    },
    BranchDetail: (branch_code) => {
      return ServiceConfig.endpoint + "/agent/branch/" + branch_code;
    },
    TransactionRate: ServiceConfig.endpoint + "/agent/transaction/send/rate",
    TransactionSave: ServiceConfig.endpoint + "/agent/transaction/send/save",
    TransactionValid: ServiceConfig.endpoint + "/agent/transaction/valid",
    TransactionOTP:
      ServiceConfig.endpoint + "/agent/transaction/validation/code",
    LicenseBlur: ServiceConfig.endpoint + "/license/blur",
    UpdateKycStatus: ServiceConfig.endpoint + "/agent/user/update/kyc/",
    ResetFailedCount: ServiceConfig.endpoint + "/agent/user/reset/failed/",
    Version: ServiceConfig.endpoint + "/version",
    CustomerFileData: ServiceConfig.endpoint + "/agent/user/file",
    ConfirmAccount: ServiceConfig.endpoint + "/agent/user/account/confirm",
    ExpiredCustomerList: ServiceConfig.endpoint + "/agent/expiredcustomers",
    isExpiredWithdrawalAccount(customerIdx: string) {
      return ServiceConfig.endpoint + "/agent/expiredwithdrawal?customerIdx=" + customerIdx;
    },
    GetServiceListByPartner(partner_id: string) {
      return ServiceConfig.endpoint + "/agent/servicelist/" + partner_id;
    },
    sendUserPwChangePassCode(idx: string) {
      return (
        ServiceConfig.endpoint + "/agent/sendpasscode/passwordchange/" + idx
      );
    },
    TransactionRefreshDeposit:
      ServiceConfig.endpoint + "/agent/transaction/validation/deposit/renew",
    TransactionCheckDeposit:
      ServiceConfig.endpoint + "/agent/transaction/validation/deposit",
    SendPdfEmail(type: string) {
      return ServiceConfig.endpoint + "/agent/sendpdf/" + type;
    },
    SendImgs: ServiceConfig.endpoint + "/agent/sendcertsimgs",
    DeleteAccount: ServiceConfig.endpoint + "/agent/delete/account",
    CustomerModifyValid: ServiceConfig.endpoint + "/agent/customer/updatevalid",
    // SendExcelEmail: ServiceConfig.endpoint + '/agent/sendemail/excel/txn'
    AccountValidation:
      ServiceConfig.endpoint + "/agent/customer/account/validate",
    DepositHistyoryList: ServiceConfig.endpoint + "/agent/deposit/list",
    DepositInfo: ServiceConfig.endpoint + "/agent/deposit/info",
    OutTransactionComment:
      ServiceConfig.endpoint + "/agent/transaction/outbound/comment",
    GetPayoutBranches:
      ServiceConfig.endpoint + "/agent/transaction/send/bankbranch",
    SendAuthCodeToStaff:
      ServiceConfig.endpoint + "/agent/sendemail/customer/bankaccauthcode",
    CustomerCountByKyc: ServiceConfig.endpoint + "/agent/customer/kyccount",
    PayoutPartnerGroupList:
      ServiceConfig.endpoint + "/agent/partner/grouplist/payout",
    RequestReauthEmail: ServiceConfig.endpoint + "/agent/request/reauth/email",
    CustomerAccouintList: ServiceConfig.endpoint + "/agent/account-list",
    QueryStatusAuthEmail(customer_idx) {
      return (
        ServiceConfig.endpoint +
        "/agent/query/status/auth/email?customer_idx=" +
        customer_idx
      );
    },
    FindCustomerPassNo: (customerIdx: string) =>
      `${ServiceConfig.endpoint}/agent/passport/${customerIdx}`,
    FindCustomerAlineCard: (customerIdx: string) =>
      `${ServiceConfig.endpoint}/agent/aliencard/${customerIdx}`,
  },
  Admin: {
    AMLCheck: ServiceConfig.endpoint + "/aml/check",
    AMLCheckOFAC: ServiceConfig.endpoint + "/admin/inbound/check/ofac",
    AMLCheckRemittance:
      ServiceConfig.endpoint + "/admin/inbound/check/remittance",
    AMLCheckOtherSender:
      ServiceConfig.endpoint + "/admin/inbound/check/othersender",
    Login: ServiceConfig.endpoint + "/admin/login",
    Logout: ServiceConfig.endpoint + "/admin/logout",
    Time: ServiceConfig.endpoint + "/admin/time",
    Home: ServiceConfig.endpoint + "/admin/home",
    SanctionStatus: ServiceConfig.endpoint + "/admin/sanction/status",
    SanctionRefresh: ServiceConfig.endpoint + "/admin/sanction/refresh",
    PartnerDetail: (partner_id) => {
      return ServiceConfig.endpoint + "/admin/partner/" + partner_id;
    },
    FXPartner: ServiceConfig.endpoint + "/admin/fxrate/partners",
    FXPayoutPartner: ServiceConfig.endpoint + "/admin/fxrate/payoutpartners",
    FXCountryRates: (partner_id) => {
      return (
        ServiceConfig.endpoint + "/admin/fxrate/" + partner_id + "/country"
      );
    },
    FXCountryUpdate: (partner_id, idx) => {
      return (
        ServiceConfig.endpoint +
        "/admin/fxrate/" +
        partner_id +
        "/country/" +
        idx +
        "/update"
      );
    },
    FXPartnerUpdate: (partner_id, idx) => {
      return (
        ServiceConfig.endpoint +
        "/admin/fxrate/" +
        partner_id +
        "/partner/" +
        idx +
        "/update"
      );
    },
    FXPartnerRates: (partner_id) => {
      return (
        ServiceConfig.endpoint + "/admin/fxrate/" + partner_id + "/partner"
      );
    },
    FXPartnerRate: ServiceConfig.endpoint + "/admin/fxrate/partners/rate",
    FxNewCountryRate: (partner_id: string) => {
      return (
        ServiceConfig.endpoint + "/admin/fxrate/" + partner_id + "/country/new"
      );
    },
    FxNewPartnerRate: (partner_id: string) => {
      return (
        ServiceConfig.endpoint + "/admin/fxrate/" + partner_id + "/partner/new"
      );
    },
    FxDeleteRate: (rate_idx: string) => {
      return ServiceConfig.endpoint + "/admin/fxrate/" + rate_idx + "/delete";
    },
    SVCChargePartner: ServiceConfig.endpoint + "/admin/servicecharge/partners",
    SVCChargePayoutPartner:
      ServiceConfig.endpoint + "/admin/servicecharge/payoutpartners",
    SVCChargePartnerRates: (partner_id) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/partner"
      );
    },
    SVCChargeCountryRates: (partner_id) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/country"
      );
    },
    SVCCharge3rdPartyRates: (partner_id) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/3rdpartyagent"
      );
    },
    SVCChargeCountryUpdate: (partner_id, idx) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/country/" +
        idx +
        "/update"
      );
    },
    SVCChargePartnerUpdate: (partner_id, idx) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/partner/" +
        idx +
        "/update"
      );
    },
    SVCCharge3rdPartyUpdate: (partner_id, idx) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/3rdpartyagent/" +
        idx +
        "/update"
      );
    },
    SVCChargeNewCountryCharge: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/country/new"
      );
    },
    SVCChargeNewPartnerCharge: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/partner/new"
      );
    },
    SVCChargeNew3rdPartyCharge: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/3rdpartyagent/new"
      );
    },
    SVCChargeUpdateCountryCharge: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/country/update"
      );
    },
    SVCChargeUpdatePartnerCharge: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/partner/update"
      );
    },
    SVCChargeUpdate3rdPartyCharge: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/3rdpartyagent/update"
      );
    },
    SVCChargeDetailOtherbank: (partner_id: string, target_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/target/" +
        target_id +
        "/AccountDepositOtherBank"
      );
    },
    SVCChargeDetailCash: (partner_id: string, target_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/target/" +
        target_id +
        "/Cash"
      );
    },
    SVCChargeDetailBank: (partner_id: string, target_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/target/" +
        target_id +
        "/AccountDeposit"
      );
    },
    SVCChargeDetailEwallet: (partner_id: string, target_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/target/" +
        target_id +
        "/E_Wallet"
      );
    },
    // SVCChargeDetailByType: (partner_id: string, target_id: string, type: string) => {
    //   return ServiceConfig.endpoint + '/admin/servicecharge/' + partner_id + '/target/' + target_id + '/' + type;
    // },
    SVCChargeDetailRDA: (partner_id: string, target_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/target/" +
        target_id +
        "/RDA"
      );
    },
    SVCChargeDetailAll: (partner_id: string, target_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/servicecharge/" +
        partner_id +
        "/target/" +
        target_id +
        "/"
      );
    },
    SVCChargeDelete: (idx: string) => {
      return ServiceConfig.endpoint + "/admin/servicecharge/" + idx + "/delete";
    },
    SVCChargeDetail: (idx: string) => {
      return ServiceConfig.endpoint + "/admin/servicecharge/" + idx;
    },

    FxHistoryRemitters:
      ServiceConfig.endpoint + "/admin/fxrate/history/remitters",
    FxHistoryPartners: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/fxrate/history/" +
        partner_id +
        "/partners"
      );
    },
    FxHistoryCountries: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/fxrate/history/" +
        partner_id +
        "/countries"
      );
    },
    FxHistory: ServiceConfig.endpoint + "/admin/fxrate/history",
    ReportPartner: ServiceConfig.endpoint + "/admin/report/partners",
    ReportInbPartner: ServiceConfig.endpoint + "/admin/report/inbpartners",

    ReportPartnerDetail: (partner_id: string) => {
      return (
        ServiceConfig.endpoint + "/admin/report/" + partner_id + "/settlement"
      );
    },
    ReportBOKDaily: () => {
      return ServiceConfig.endpoint + "/admin/report/bok/daily";
    },
    ReportBOKEdit: () => {
      return ServiceConfig.endpoint + "/admin/report/bok/edit/report";
    },
    InboundReportBOKDaily: () => {
      return ServiceConfig.endpoint + "/admin/report/bok/daily/inbound";
    },
    InbReportPartnerDetail: (partner_id: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/report/" +
        partner_id +
        "/settlementInb"
      );
    },

    CustomerList: ServiceConfig.endpoint + "/admin/customer",
    CustomerRegister: ServiceConfig.endpoint + "/admin/customer/registration",
    CustomerCheck:
      ServiceConfig.endpoint + "/admin/customer/registration/check",
    CustomerAccountRegistration:
      ServiceConfig.endpoint + "/admin/customer/account/registration",
    CustomerAccountValidation:
      ServiceConfig.endpoint + "/admin/customer/account/validation",
    AccountValidation:
      ServiceConfig.endpoint + "/admin/customer/account/validate",
    AccountValidForceApprove:
      ServiceConfig.endpoint + "/admin/customer/account/validate/forceApprove",
    ConfirmAccount: ServiceConfig.endpoint + "/admin/customer/account/confirm",
    CustomerModify: ServiceConfig.endpoint + "/admin/customer/update",
    CustomerStatistics: (id, year, type) => {
      return (
        ServiceConfig.endpoint +
        "/admin/customer/" +
        id +
        "/" +
        year +
        "/" +
        type +
        "/statistics"
      );
    },
    CustomerRemittance: (id) => {
      return ServiceConfig.endpoint + "/admin/customer/" + id + "/remittance";
    },
    CustomerValidateMobile:
      ServiceConfig.endpoint + "/admin/customer/validate/mobile",
    CustomerValidateMobileResult:
      ServiceConfig.endpoint + "/admin/customer/validate/mobile/result",
    CustomerReAuthMobile:
      ServiceConfig.endpoint + "/admin/customer/validate/mobile/reauth",
    CustomerVerifyMobile:
      ServiceConfig.endpoint + "/admin/customer/validate/mobile/verify",
    CustomerBlock: ServiceConfig.endpoint + "/admin/customer/block",
    Transaction: ServiceConfig.endpoint + "/admin/transaction",
    InbTransaction:
      ServiceConfig.endpoint + "/admin/transaction/inbound_history",
    TransactionSubInf:
      ServiceConfig.endpoint + "/admin/transaction/subside_info",
    TransactionSubInfNew:
      ServiceConfig.endpoint + "/admin/transaction/subside_info/new",
    TransactionSubInfUpdate:
      ServiceConfig.endpoint + "/admin/transaction/subside_info/update",
    TransactionDetail: ServiceConfig.endpoint + "/admin/transaction",
    InbTransactionDetail:
      ServiceConfig.endpoint + "/admin/transaction/inbound_detail",
    InbTransactionRefundClaim:
      ServiceConfig.endpoint + "/admin/transaction/inbound_detail/refund/claim",
    InbTransactionRefundResult:
      ServiceConfig.endpoint +
      "/admin/transaction/inbound_detail/refund/result",
    InbTransactionRefundGetInfo:
      ServiceConfig.endpoint +
      "/admin/transaction/inbound_detail/refund/getinfo",
    InbTransactionRefundIsClaim:
      ServiceConfig.endpoint +
      "/admin/transaction/inbound_detail/refund/isrefund",
    TransactionCancel: ServiceConfig.endpoint + "/admin/transaction/cancel",
    TransactionApprove: ServiceConfig.endpoint + "/admin/transaction/approve",
    InbTransactionApprove:
      ServiceConfig.endpoint + "/admin/transaction/inbound/Approved",
    InbTransactionForceApprove:
      ServiceConfig.endpoint + "/admin/transaction/inbound/ForceApproved",
    TransactionReadytoPay:
      ServiceConfig.endpoint + "/admin/transaction/inbound/ReadyToPay",
    TransactionPending:
      ServiceConfig.endpoint + "/admin/transaction/inbound/Pending",
    InbTransactionCancel:
      ServiceConfig.endpoint + "/admin/transaction/inbound/Cancelled",
    TransactionForcedApprove:
      ServiceConfig.endpoint + "/admin/transaction/forcedapprove",
    TransactionSender:
      ServiceConfig.endpoint + "/admin/transaction/send/sender",
    AccountValidationInb:
      ServiceConfig.endpoint + "/admin/inbound/validate/account",
    AccountRegistration:
      ServiceConfig.endpoint + "/admin/inbound/register/account",
    UserTransactionList:
      ServiceConfig.endpoint + "/admin/user/transaction/list",
    UserNationalityList:
      ServiceConfig.endpoint + "/admin/user/nationality/list",
    UserOccupationList: ServiceConfig.endpoint + "/admin/customer/occupations",
    QSBranchList: ServiceConfig.endpoint + "/admin/branch/list",
    agentInfoUpdate: ServiceConfig.endpoint + "/admin/customer/agent/type",

    TransactionReceiver: (id) => {
      return (
        ServiceConfig.endpoint +
        "/admin/transaction/send/sender/" +
        id +
        "/receiver"
      );
    },
    TransactionCountry:
      ServiceConfig.endpoint + "/admin/transaction/send/country",
    TransactionPayoutBranch: (partner, bank_code) => {
      return (
        ServiceConfig.endpoint +
        "/admin/transaction/send/" +
        partner +
        "/bank/" +
        bank_code +
        "/branch"
      );
    },
    TransactionPayoutBank: (partner) => {
      return (
        ServiceConfig.endpoint + "/admin/transaction/send/" + partner + "/bank"
      );
    },
    TransactionPayoutBankByType: (partner, type) => {
      return (
        ServiceConfig.endpoint +
        "/admin/transaction/send/" +
        partner +
        "/bank/" +
        type
      );
    },
    TransactionPayoutCashBranch: (partner) => {
      return (
        ServiceConfig.endpoint + "/admin/transaction/send/" + partner + "/cash"
      );
    },
    TransactionPayoutBranchByType: (partner, type) => {
      return (
        ServiceConfig.endpoint +
        "/admin/transaction/send/" +
        partner +
        "/" +
        type
      );
    },
    BranchDetail: (partner_id, branch_code) => {
      return (
        ServiceConfig.endpoint +
        "/admin/user/branch/" +
        partner_id +
        "/" +
        branch_code +
        "/detail"
      );
    },
    TransactionSubInfDelete: (value: string) => {
      return (
        ServiceConfig.endpoint +
        "/admin/transaction/subside_info/" +
        value +
        "/delete"
      );
    },
    BranchList: ServiceConfig.endpoint + "/admin/user/branch",
    BranchNew: ServiceConfig.endpoint + "/admin/user/branch/new",
    BranchUpdate: ServiceConfig.endpoint + "/admin/user/branch/update",
    AgentList: ServiceConfig.endpoint + "/admin/user/agent",
    AgentNew: ServiceConfig.endpoint + "/admin/user/agent/new",
    AgentUpdate: ServiceConfig.endpoint + "/admin/user/agent/update",
    AgentDetail: (id) => {
      return ServiceConfig.endpoint + "/admin/user/agent/" + id + "/detail";
    },
    TransactionRate: ServiceConfig.endpoint + "/admin/transaction/send/rate",
    TransactionSave: ServiceConfig.endpoint + "/admin/transaction/send/save",
    TransactionValid: ServiceConfig.endpoint + "/admin/transaction/valid",
    TransactionOTP:
      ServiceConfig.endpoint + "/admin/transaction/validation/code",
    TransactionCheckDeposit:
      ServiceConfig.endpoint + "/admin/transaction/validation/deposit",
    TransactionCheckDetail:
      ServiceConfig.endpoint + "/admin/transaction/inbound/checkdetail",
    TransactionRefreshDeposit:
      ServiceConfig.endpoint + "/admin/transaction/validation/deposit/renew",
    TransactionUpdate: ServiceConfig.endpoint + "/admin/transaction/update",
    transactionRefundedUpdate:
      ServiceConfig.endpoint + "/admin/transaction/update/refunded",
    TransactionComment:
      ServiceConfig.endpoint + "/admin/transaction/inbound/comment",
    OutTransactionComment:
      ServiceConfig.endpoint + "/admin/transaction/outbound/comment",
    FIUReport: ServiceConfig.endpoint + "/admin/fiureport",
    FIUReportDetail: ServiceConfig.endpoint + "/admin/fiureport/detail",
    FIUReportBlock: ServiceConfig.endpoint + "/admin/fiureport/block",
    DepositHistyoryList: ServiceConfig.endpoint + "/admin/deposit/list",
    DepositInfo: ServiceConfig.endpoint + "/admin/deposit/info",
    SelectedDepositInfoByEmail:
      ServiceConfig.endpoint + "/admin/deposit/selected",
    UpdateKycStatus: ServiceConfig.endpoint + "/admin/user/update/kyc/",
    ResetFailedCount: ServiceConfig.endpoint + "/admin/user/reset/failed/",
    Notice: ServiceConfig.endpoint + "/admin/notice",
    NoticeList: ServiceConfig.endpoint + "/admin/notice/list",
    NoticeInsert: ServiceConfig.endpoint + "/admin/notice/insert",
    NoticeUpdate: ServiceConfig.endpoint + "/admin/notice/update",
    NoticeDelete: ServiceConfig.endpoint + "/admin/notice/delete",
    NoticeAlwaysOptionUpdate:
      ServiceConfig.endpoint + "/admin/notice/updatelist",
    Push: ServiceConfig.endpoint + "/admin/push",
    PushList: ServiceConfig.endpoint + "/admin/push/list",
    PushInsert: ServiceConfig.endpoint + "/admin/push/insert",
    PushUpdate: ServiceConfig.endpoint + "/admin/push/update",
    PushDelete: ServiceConfig.endpoint + "/admin/push/delete",
    Version: ServiceConfig.endpoint + "/version",
    CustomerFileData: ServiceConfig.endpoint + "/admin/customer/file",
    InboundForcePaid(id: string) {
      return ServiceConfig.endpoint + "/admin/inbforcepaid?id=" + id;
    },
    MobileVersion: ServiceConfig.endpoint + "/admin/mobile/version",
    MobileVersionList: ServiceConfig.endpoint + "/admin/mobile/version/list",
    MobileVersionInsert:
      ServiceConfig.endpoint + "/admin/mobile/version/insert",
    MobileVersionUpdate:
      ServiceConfig.endpoint + "/admin/mobile/version/update",
    MobileVersionDelete:
      ServiceConfig.endpoint + "/admin/mobile/version/delete",
    ExpiredCustomerList: ServiceConfig.endpoint + "/admin/expiredcustomers",
    isExpiredWithdrawalAccount(customerIdx: string) {
      return (
        ServiceConfig.endpoint +
        "/admin/expiredwithdrawal?customerIdx=" +
        customerIdx
      );
    },
    GetServiceListByPartner(partner_id: string) {
      return ServiceConfig.endpoint + "/admin/servicelist/" + partner_id;
    },
    MyPage: ServiceConfig.endpoint + "/admin/mypage/confirm",
    MyPageUpdate: ServiceConfig.endpoint + "/admin/mypage/update",
    PasswordUpdate: ServiceConfig.endpoint + "/admin/password/update",
    SendPdfEmail(type: string) {
      return ServiceConfig.endpoint + "/admin/sendpdf/" + type;
    },
    SendImgs: ServiceConfig.endpoint + "/admin/sendcertsimgs",
    DeleteAccount: ServiceConfig.endpoint + "/admin/delete/account",
    CustomerModifyValid: ServiceConfig.endpoint + "/admin/customer/updatevalid",
    SendExcelEmail: ServiceConfig.endpoint + "/admin/sendemail/excel/txn",
    GetPayoutBranches:
      ServiceConfig.endpoint + "/admin/transaction/send/bankbranch",
    SendAuthCodeToStaff:
      ServiceConfig.endpoint + "/admin/sendemail/customer/bankaccauthcode",
    GetDepositPartners:
      ServiceConfig.endpoint + "/admin/inbound/deposit/partnerlist",
    AllowOutboundTxn: ServiceConfig.endpoint + "/admin/allowouttxn",
    CustomerCountByKyc: ServiceConfig.endpoint + "/admin/customer/kyccount",
    DailyMailingLists:
      ServiceConfig.endpoint + "/admin//report/bok/daily/mailing",
    InsertDailyMailingList:
      ServiceConfig.endpoint + "/admin//report/bok/daily/mailing/insert",
    DeleteDailyMailingLists:
      ServiceConfig.endpoint + "/admin//report/bok/daily/mailing/delete",
    PayoutPartnerGroupList:
      ServiceConfig.endpoint + "/admin/partner/grouplist/payout",
    RequestReauthEmail: ServiceConfig.endpoint + "/admin/request/reauth/email",
    QueryStatusAuthEmail(customer_idx) {
      return (
        ServiceConfig.endpoint +
        "/admin/query/status/auth/email?customer_idx=" +
        customer_idx
      );
    },
    EditBeneficaryInfo: ServiceConfig.endpoint + "/admin/edit/beneinfo",
    CustomerAccouintList: ServiceConfig.endpoint + "/admin/account-list",
    ApproveRealName: ServiceConfig.endpoint + "/admin/account/approve-real-name",
    RefreshKftcDate: ServiceConfig.endpoint + "/admin/refresh/kftc-agree-date",
    RefreshKftcToken: ServiceConfig.endpoint + "/admin/refresh/kftc-token",
    SendThreeDigitCodeEmail:
      ServiceConfig.endpoint + "/admin/sendemail/three-digit-code",
    FindORISReports: (offset: number, pageSize: number) =>
      `${ServiceConfig.endpoint}/oris/reports?offset=${offset}&pageSize=${pageSize}`,
    FindORISReportsByOption: `${ServiceConfig.endpoint}/oris/reports/search`,
    SubmitORISReport: `${ServiceConfig.endpoint}/oris/reports/submit`,
    FindCustomerPassNo: (customerIdx: string) =>
      `${ServiceConfig.endpoint}/admin/passport/${customerIdx}`,
    FindCustomerAlineCard: (customerIdx: string) =>
      `${ServiceConfig.endpoint}/admin/aliencard/${customerIdx}`,
    ResendORISReport: `${ServiceConfig.endpoint}/oris/reports/resend`,
    FindBOKReportsByOption: `${ServiceConfig.endpoint}/oris/bok/reports`,
    DeleteORISReports: `${ServiceConfig.endpoint}/oris/bok/reports/delete`,
    GetOrisAccmulatedAmount: `${ServiceConfig.endpoint}/oris/accumulated-amount`,
    GetBOKReportDetail: `${ServiceConfig.endpoint}/oris/bok/report/detail`,
    GetOrphanedReports: (dateFrom: string) =>
      `${ServiceConfig.endpoint}/oris/reports/orphaned?dateFrom=${dateFrom}`,
    CancelOrphanedReports: (dateFrom: string) =>
      `${ServiceConfig.endpoint}/oris/reports/orphaned/cancel?dateFrom=${dateFrom}`,
    GetUnreportedTransactions: (dateFrom: string) =>
      `${ServiceConfig.endpoint}/oris/reports/unreported?dateFrom=${dateFrom}`,
    RetryFailedORISReports: (dateFrom: string) =>
      `${ServiceConfig.endpoint}/oris/reports/failed/retry?dateFrom=${dateFrom}`,
    GetReconciliation: (dateFrom: string, dateTo: string, includeOrisCheck: boolean) =>
      `${ServiceConfig.endpoint}/oris/reconciliation?dateFrom=${dateFrom}&dateTo=${dateTo}&includeOrisCheck=${includeOrisCheck}`,
    GetReportMonitor: (dateFrom: string, dateTo: string, includeOrisCheck: boolean) =>
      `${ServiceConfig.endpoint}/oris/reports/monitor?dateFrom=${dateFrom}&dateTo=${dateTo}&includeOrisCheck=${includeOrisCheck}`,
    BackfillReport: `${ServiceConfig.endpoint}/oris/reports/backfill`,
    BokSenderOverrideList: `${ServiceConfig.endpoint}/admin/report/bok/sender-override`,
    BokSenderOverrideUpsert: `${ServiceConfig.endpoint}/admin/report/bok/sender-override`,
    BokSenderOverrideBulk: `${ServiceConfig.endpoint}/admin/report/bok/sender-override/bulk`,
    BokSenderOverrideDelete: (customerId: string) =>
      `${ServiceConfig.endpoint}/admin/report/bok/sender-override/${customerId}/delete`,
  },
  Common: {
    session: ServiceConfig.endpoint + "/access/session",
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/config/api.ts